(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(
      ".section-announcement, .section-goated-announcement"
    );
    if (!annBar) return;

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;
    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);

      if (annBar.classList.contains("section-goated-announcement")) {
        document.documentElement.style.setProperty(
          "--announcement-height",
          `${annBarHeight.toFixed(2)}px`
        );
      }

      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };
    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );
      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });
      updateHeight(lastRatio);
      window.requestAnimationFrame(() => updateHeight(lastRatio));
      intersectionObserver.observe(annBar);
      resizeObserver.observe(annBar);
    };
    createObservers();
  };
  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);
  initAnnBar();
})();
if (!customElements.get("announcement-countdown")) {
  class AnnouncementCountdown extends HTMLElement {
    constructor() {
      super();
      this.userDate = this.getAttribute("data-date");
      this.userTime = this.getAttribute("data-time");
      this.mockTimer = this.getAttribute("data-mock-timer");
      if (this.mockTimer === "true") {
        const INFINITE_DAYS = this.getAttribute("data-mock-days")
          ? Number(this.getAttribute("data-mock-days"))
          : 2;
        const DIFF_HOURS = this.getAttribute("data-mock-hours")
          ? Number(this.getAttribute("data-mock-hours"))
          : 3;
        const now = new Date();
        const futureDate = new Date(
          now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
        );
        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, "0");
        const day = String(futureDate.getDate()).padStart(2, "0");
        const hours = String(futureDate.getHours()).padStart(2, "0");
        const minutes = String(futureDate.getMinutes()).padStart(2, "0");
        this.userDate = `${year}-${month}-${day}`;
        this.userTime = `${hours}:${minutes}`;
      }
      this.interval;
      this.onInit(this.userDate, this.userTime);
      this.setInterval(this.userDate, this.userTime);
    }
    onInit(userDate, userTime) {
      this.completedCountdown = this.getAttribute("data-completed");
      this.countdown = this.querySelector(".announcement-bar-countdown__main");
      this.countdownHeading = this.querySelector(
        ".announcement-bar-countdown__end-info"
      );
      this.daysEl = this.querySelector(
        ".announcement-bar-countdown_block_days"
      );
      this.hoursEl = this.querySelector(
        ".announcement-bar-countdown_block_hours"
      );
      this.minutesEl = this.querySelector(
        ".announcement-bar-countdown_block_minutes"
      );
      this.secondsEl = this.querySelector(
        ".announcement-bar-countdown_block_seconds"
      );
      this.section = this.closest(".section-announcement");
      const countdownDate = new Date(`${userDate}T${userTime}`);
      const now = new Date();
      const distance = countdownDate.getTime() - now.getTime();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance < 0 && this.completedCountdown === "hide_section") {
        clearInterval(this.interval);
        this.section.style.display = "none";
      } else if (distance < 0 && this.completedCountdown === "show_text") {
        clearInterval(this.interval);
        this.countdown.style.display = "none";
        this.countdownHeading.style.display = "flex";
      } else {
        if (String(days).length === 1) this.daysEl.textContent = "0" + days;
        else this.daysEl.textContent = days;
        if (String(hours).length === 1) this.hoursEl.textContent = "0" + hours;
        else this.hoursEl.textContent = hours;
        if (String(minutes).length === 1)
          this.minutesEl.textContent = "0" + minutes;
        else this.minutesEl.textContent = minutes;
        if (String(seconds).length === 1)
          this.secondsEl.textContent = "0" + seconds;
        else this.secondsEl.textContent = seconds;
      }
    }
    setInterval(userDate, userTime) {
      clearInterval(this.interval);
      this.interval = setInterval(
        this.onInit.bind(this, userDate, userTime),
        1000
      );
    }
  }
  customElements.define("announcement-countdown", AnnouncementCountdown);
}
